import React from "react";
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
} from "react-google-maps";
import InfoBox from "react-google-maps/lib/components/addons/InfoBox";

const Map = ({hotels,destinations,hoverMap}) => {
  
const options = { closeBoxURL: "", enableEventPropagation: true };

  return (
    <div>
      {
    hotels
    .filter(
        (hotel) =>
          
        hotel.destination_id===hoverMap ||
          destinations == "" ||
          destinations == null ||
        hotel.destination_id === destinations
          
      ).map((map)=>{
              return(
                <GoogleMap
        defaultZoom={8}
        defaultCenter={{ lat: 21.188414, lng: 106.076744 }}
        
      >
            <Marker
                icon={{
                  url: "/images/ic_hotel.png",
                  scaledSize: new window.google.maps.Size(40, 40),
                }}
                position={new window.google.maps.LatLng(map)}
              >
                <InfoBox options={options}>
                    <div
                      style={{
                        backgroundColor: "#fff",
                        color: "#000",
                        borderRadius: "1em",
                        padding: "3px 10px",
                      }}
                    >
                      {map.name}
                    </div>
                </InfoBox>
              </Marker>
      </GoogleMap>
              )
            })}
        
    </div>
  );
};

export default withScriptjs(withGoogleMap(Map));
